<template>
  <div>
    <b-row>
      <b-col>
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="sidebarVisible = !sidebarVisible"
          pill
          style="position: absolute; top: 1rem;"
        >
          {{ $route.query.name || 'Menu' }}
        </b-button>
        <b-sidebar
          v-model="sidebarVisible"
          class="pbi-sidebar"
          id="sidebar-dashboard-menu"
          title="Dashboard"
          bg-variant="dark"
          text-variant="light"
          shadow
        >
          <side-bar
            :menu="filteredList"
            @dashboardSelected="dashboardSelected"
          />
        </b-sidebar>
        <pbi-report-viewer :powerBiEmbedUrlId="powerBiEmbedUrlId" brand="All" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from 'lodash';
import http from '@/mixins/http';
import SideBar from '@/components/dashboard/SideBar';
import PbiReportViewer from "@/views/dashboard/PbiReportViewer";

export default {
  name: 'Business',
  mixins: [http],
  components: { SideBar, PbiReportViewer },
  mounted() {
    this.getMenu();
  },
  watch: {
    '$route.params'() {
      this.powerBiEmbedUrlId = this.$route.params.id;
    },
  },
  data() {
    return {
      sidebarVisible: true,
      selectedDashboard: 'Menu',
      powerBiEmbedUrlId: '',
      list: [
        {
          dashboardId: 1,
          title: 'Business Performance',
          href: null,
          parentId: -1,
        },
      ],
    };
  },
  computed: {
    filteredList() {
      let list = _.sortBy(this.list, ['parentId']);
      // remove /dashboard from the url due to legacy settings
      list = _.map(list, item => {
        if (item.href) {
          item.href = item.href.replace('/dashboard', '');
        }
        return item;
      });

      const roots = _.filter(list, { parentId: 1 });
      return _.map(roots, root => {
        return this.getNestedList(root, list);
      });
    },
  },
  methods: {
    getMenu() {
      this.axios.get('/api/businessDashboard/dashboards').then(resp => {
        if (resp.data) {
          this.list = resp.data;
        }
      });
    },
    dashboardSelected(dashboardName) {
      this.selectedDashboard = dashboardName;
    },
    getNestedList(root, adjacencyList) {
      const added = {};
      const rootNode = _.cloneDeep(root);
      const SetDepth = function(currentNode) {
        added[currentNode.dashboardId] = true;
        while (
          _.some(adjacencyList, function(node) {
            return (
              node.parentId === currentNode.dashboardId &&
              !added[node.dashboardId]
            );
          })
        ) {
          let childNode = _.find(adjacencyList, function(node) {
            return (
              node.parentId === currentNode.dashboardId &&
              !added[node.dashboardId]
            );
          });
          if (!Object.prototype.hasOwnProperty.call(currentNode, 'child')) {
            currentNode.child = [];
          }
          if (
            !_.some(currentNode.child, { dashboardId: childNode.dashboardId })
          ) {
            currentNode.child.push(childNode);
          }
          added[childNode.dashboardId] = true;
          SetDepth(childNode, adjacencyList);
        }
      };
      if (rootNode) {
        SetDepth(rootNode);
      }
      return rootNode;
    },
  },
};
</script>

<style scoped></style>